import { useEffect, useState } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";

import { toast } from "@/design-system/components/Toast/Toast";

import { makeRequest } from "@/util";

type AutocompleteType = {
  value: string;
  onChange: (value: string) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange">;

type MasqueradeUser = {
  Email: string;
  AccountUserCount?: number;
};

type MasqueradeResponse = {
  data: MasqueradeUser[];
};

export const AutocompleteMasquerade = ({
  value,
  onChange,
  ...rest
}: AutocompleteType) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<string[]>([]);
  const [visibleOptions, setVisibleOptions] = useState<string[]>([]);

  useEffect(() => {
    if (open) {
      setVisibleOptions(options);
    } else {
      setVisibleOptions([]);
    }
  }, [open, options]);

  useEffect(() => {
    makeRequest("autocomplete_masquerade", { masquerade_value: value })
      .then((response) => {
        const typedResponse = response as MasqueradeResponse;
        // NOTE(bianchi): ostensibly, we could display the AccountUserCount in the dropdown, but it was breaking when I tried that
        setOptions(typedResponse.data.map((user) => user.Email));
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong");
      });
  }, [value]);

  return (
    <Autocomplete
      id="Value"
      value={value}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={visibleOptions}
      // When first navigating to an event, onInputChange seems to be
      // fired even though it shouldn't be. This is causing issues with
      // the event being marked as edited when it shouldn't be.
      onInputChange={(event, value) => event && onChange(value.trim())}
      freeSolo={true}
      disableClearable={true}
      loading={false}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <input value={value} {...params.inputProps} {...rest} />
        </div>
      )}
    />
  );
};
